import React, { useEffect, useRef, useState } from "react";
import Widget from "../../Widget/Widget";
import SettingsModal from "../../Modal/SettingsModal";
import MyBoardsSettingsModal from "../WidgetsSettings/MyBoardsSettings/MyBoardsSettingsModal";
import { useSelector } from "react-redux";
import SingleBoard from "./SingleBoard";
import "./MyBoardsWidget.less";
import { sortByBoardOrder } from "../../../containers/Sidebar/SidebarScripts";
import { useLocation } from "react-router-dom";

interface MyBoardsProps {
   value: any;
   role: any;
}

const MyBoards: React.FC<MyBoardsProps> = ({ value, role }) => {
   const [containerWidth, setContainerWidth] = useState<number>(0);

   const { boards } = useSelector(({ boards }) => boards);
   const location = useLocation();

   const containerRef = useRef<HTMLDivElement | null>(null);

   // we are changing class name basing on parent container width. Parent container widht changes when widget
   // widht changes
   useEffect(() => {
      const currentContainer = containerRef.current;
      if (!currentContainer) return;

      const updateWidth = () => {
         setContainerWidth(currentContainer.clientWidth);
      };

      updateWidth();

      const resizeObserver = new ResizeObserver(updateWidth);
      resizeObserver.observe(currentContainer);

      return () => {
         resizeObserver.unobserve(currentContainer);
      };
   }, []);

   return (
      <Widget
         //@ts-ignore
         styleName="gx-m-0"
         className="my-boards-widget"
         bgColor={"transparent"}
         style={{ border: "none", boxShadow: "none" }}
         role={role}
         extra={
            (role === "OWNER" || role === "MODERATOR") && (
               //@ts-ignore
               <SettingsModal
                  widgetId={value.id}
                  widgetName={value.name}
                  icon="setting"
                  deleteIcon="true"
                  children={<MyBoardsSettingsModal value={value} />}
               />
            )
         }
      >
         <div ref={containerRef} className="my-boards-widget-container">
            {sortByBoardOrder(boards)?.map((board) =>
               board?.hidden || board?.url === location?.pathname ? null : (
                  <SingleBoard key={board.id} boardData={board} parentWidth={containerWidth} />
               ),
            )}
         </div>
      </Widget>
   );
};

export default MyBoards;
